import React, { Fragment, useContext } from 'react'
import './Styles.css';
import {LangCtx, PayLoadCtx} from "../../lib/context";
import { langObj } from "../../locale/index";
import DropDown from "../../lib/ui/dropdown/Dropdown";
import langOptions from "../../config/langOptions.json";
const Header = (props) => {
    const {l, setLang} = useContext(LangCtx);
    const {payload} = useContext(PayLoadCtx);
    // console.log("payload in headers======", payload);

    const handleLang = (e) => {
        setLang(langObj[e.target.value]);
        localStorage.setItem('lang', e.target.value);
    }
    
    return <Fragment>
        <div className="appBar">
            <div className="appIconBox" onClick={props.handleSlide}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className="brandingBox">
                <div className="logoBox">
                    <img src="/images/logos/logo.png" className="lgLogo invertWhite" alt="logo" />
                </div>
            </div>
            <div className="innerLangBlock">
                <DropDown placeholder="Languages" items={langOptions} value={localStorage.getItem('lang') ? localStorage.getItem('lang') : l.locale} onChange={handleLang} />
            </div>
            <div className="webAppBarAction">
                <span className="wlcomTxt">{l.welcome} <small>{payload && payload.name ? payload.name : ''}</small></span>
                <div className="avtrCircle">
                    <img src={payload && payload.profileImage && payload.profileImage.url ? payload.profileImage.url : "/images/icons/profile-outline.png"} className={payload &&payload.profileImage && payload.profileImage.url ? "" : "invertWhite"} alt="logo" />
                </div>
            </div>
            
        </div>
    </Fragment>
}
export default Header;

